import React, { useContext, useState, useEffect } from "react";
import { UserAuthContext } from "../../../App";
import { getStoresApi } from "../../../Apis/StoreApi";

const MyStoreContact = () => {
  const { userUid } = useContext(UserAuthContext);
  const [storeDetails, setStoreDetails] =useState([]);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");


  const getStoreDetails = async()=>{
    try{
      const response = await getStoresApi(userUid?.currentUser?.uid);
      if (response && response?.store) {
        setStoreDetails(response.store);
      }
    }catch(error){
      console.log("Failed to fetch the data ", error);
    }
  }

  useEffect(() => {
    if (userUid?.currentUser) {
      getStoreDetails();
      setPhone(userUid.currentUser.phoneNumber || "");
      setEmail(userUid.currentUser.email || "");
    }
  }, [userUid?.currentUser]);

  const displayPhone = storeDetails.phoneNumber || phone;


  return (
    <div className="w-[891px] h-[620px] rounded-b-[5px] bg-white pt-[26px] flex flex-col items-center">
      <div className="flex flex-row justify-between w-[874px]">
        <div className="flex flex-col h-[86px] justify-between">
          <p className="w-[71px] h-[21px] text-black text-start font-semibold text-[14px]">
            Phone No.
          </p>
          <input
            type="text"
            value={displayPhone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="9876543210"
            className="p-[12px] border rounded-[5px] w-[420px] h-[51px] placeholder:w-[72px] placeholder:h-[26px] placeholder:text-[12px] placeholder:font-medium font-medium text-[12px] text-black"
          />
        </div>
        <div className="flex flex-col h-[86px] justify-between">
          <p className="w-[71px] h-[21px] text-black text-start font-semibold text-[14px]">
            Email ID
          </p>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="username123@gmail.com"
            className="p-[12px] border rounded-[5px] w-[420px] h-[51px] placeholder:w-[158px] placeholder:h-[26px] placeholder:text-[12px] placeholder:font-medium font-medium text-[12px] text-black"
          />
        </div>
      </div>
      <div className="flex flex-col mt-[29px] h-[171px] justify-between">
        <p className="w-[153px] h-[21px] text-black text-start font-semibold text-[14px]">
          Company Address
        </p>
        <textarea
          name="companyAddress"
          id="companyAddress"
          value={storeDetails.storeAddress || ""}
          rows={5}
          placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. "
          className="w-[874px] h-[136px] p-[12px] border rounded-[5px] placeholder:w-[800px] placeholder:h-[78px] placeholder:text-[12px] placeholder:font-medium font-medium text-[14px] text-black resize-none"
        ></textarea>
      </div>
    </div>
  );
};

export default MyStoreContact;
